import React from 'react'
import { PrismicRichText, PrismicLink } from '@prismicio/react'
import LocationMarker from '../svg/locationMarker'

const Locations = ({ slice }) => {
  return (
    <section className='component-location mx-auto max-w-screen-xl p-4'>
      <div className='prose prose-lg mb-10 min-w-full text-center'>
        <PrismicRichText field={slice.primary.location_title.richText} />
      </div>
      <div className='grid md:grid-cols-2'>
        {slice.items.map((location, index) => {
          return (
            <div className='location px-8 pb-10' key={`location-${index}`}>
              <h3 className='text-primary inline-flex'>
                <LocationMarker className='mr-4 w-4' />
                {location.region}
              </h3>
              <div className='ml-8'>
                <div className=' gap-6 md:grid xl:grid-cols-2'>
                  <PrismicRichText field={location.address.richText} />
                  <div className='mt-2 space-y-2'>
                    <p className=''>
                      Tel:{' '}
                      <a className='text-primary hover:text-primaryHover focus:text-blue-800' href={`tel:${location.phone}`}>
                        {location.phone}
                      </a>
                    </p>
                    {location.fax && <p className=''>Fax: {location.fax}</p>}
                    {location.email && (
                      <p className=' transform font-normal text-primary transition duration-150 ease-in-out hover:text-primaryHover focus:text-blue-800'>
                        <PrismicLink href={`mailto:${location.email}`}>{location.email}</PrismicLink>
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </section>
  )
}

export default Locations
